import React from "react";

const STATES = [
  { v: "not_included", label: "Não", testid: "tri-not-included" },
  { v: "included", label: "Incluir", testid: "tri-included" },
  { v: "bonus", label: "Bônus", testid: "tri-bonus" },
];

const CLR = {
  not_included: "bg-muted text-muted-foreground",
  included: "bg-primary text-primary-foreground",
  bonus: "bg-accent text-accent-foreground",
};

export default function TriStateToggle({ value = "not_included", onChange, testidPrefix }) {
  return (
    <div className="inline-flex border border-border rounded overflow-hidden" data-testid={`${testidPrefix}-tristate`}>
      {STATES.map((s) => (
        <button
          key={s.v}
          type="button"
          onClick={() => onChange(s.v)}
          data-testid={`${testidPrefix}-${s.testid}`}
          className={`px-3 py-1.5 text-xs font-mono uppercase tracking-wider transition-colors ${
            value === s.v ? CLR[s.v] : "bg-transparent text-muted-foreground hover:bg-muted/40"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
